(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxSitesPrinterStatus(
    $timeout, WorkstationListService, TenantListService, $location, $window, SUPPORTED_OS, NetworkListService,
    PrinterModel, URLS, URL_PARAMS, $rootScope
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        additionalContent: '=additionalContent',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/sites/sitesPrinterStatus/sitesPrinterStatus.template.html',
      link: function(scope) {

        scope.thresholdToSwitchCreatedTimeFormat = 6;
        scope.monitoringWorkstation = null;
        scope.network = scope.additionalContent;
        
        var privateStatusPrinter = scope.statusPrinter = angular.copy(scope.context);
        var privateUsageType = scope.usageType = angular.element('.context-content-container')[0] ? 'popup' : 'tabs';
        var printer = angular.copy(scope.context);

        (function() {
          sortToners();
          sortErrorsAndWarnings();
          getMonitoringWorkstation();
          removeDeprecatedErrorsAndWarnings();
          dynamicWidth()
          if (!scope.network) {
            getNetwork();
          }
        })();

        function getNetwork () {
          var url = printer._links['px:network'].href;
          NetworkListService.getNetworkByUrl(url).then(function(network) {
            scope.network = network;
          }).catch(function(error){});
        }

        function getMonitoringWorkstation() {
          if (printer._embedded.status._links['px:monitorWs']) {
            var monitoringWorkstationURL = printer._embedded.status._links['px:monitorWs'].href;
            WorkstationListService.getWorkstationByUrl(monitoringWorkstationURL).then(function(workstation) {
              scope.monitoringWorkstation = workstation.info;
            }).catch(function(error){});
          }
        }

        function sortErrorsAndWarnings () {
          if (scope.statusPrinter._embedded.status.errors) {
            scope.statusPrinter._embedded.status.errors.sort();
          }
          if (scope.statusPrinter._embedded.status.warnings) {
            scope.statusPrinter._embedded.status.warnings.sort();
          }
        }

        function sortToners () {
          if (scope.statusPrinter.type !== 'VIRTUAL' && scope.statusPrinter._embedded.status.tonerLevels) {
            scope.statusPrinter._embedded.status.tonerLevels.sort(function(a, b){
              if(a.color < b.color) { return -1; }
              if(a.color > b.color) { return 1; }
              return 0;
            })
          }
        }

        function removeDeprecatedErrorsAndWarnings () {
          if (scope.statusPrinter._embedded.status.errors) {
            for (var i = 0; i < scope.statusPrinter._embedded.status.errors.length; i++) {
              if (scope.statusPrinter._embedded.status.errors[i] === 'POLL_FAILED') {
                scope.statusPrinter._embedded.status.errors.splice(i, 1);
                break;
              }
            }
  
            if (scope.statusPrinter._embedded.status.errors.length < 1) {
              delete scope.statusPrinter._embedded.status.errors;
            }
          }
  
          if (scope.statusPrinter._embedded.status.warnings) {
            for (var j = 0; j < scope.statusPrinter._embedded.status.warnings.length; j++) {
              if (scope.statusPrinter._embedded.status.warnings[j] === 'POLL_TIMED_OUT') {
                scope.statusPrinter._embedded.status.warnings.splice(j, 1);
                break;
              }
            }
  
            if (scope.statusPrinter._embedded.status.warnings.length < 1) {
              delete scope.statusPrinter._embedded.status.warnings;
            }
          }
        }

        scope.showProxyErrorMessage = function () {
          var width = angular.element('.proxy-error-message')[0].clientWidth;
          angular.element('.proxy-error-message').css({ left: (-width / 2) + 39})
          angular.element('.proxy-error-message').css({ opacity: 1})
        }
        
        scope.hideProxyErrorMessage = function () {
          angular.element('.proxy-error-message').css({ opacity: 0})
        }
        
        scope.showMonitorErrorMessage = function () {
          var width = angular.element('.monitor-error-message')[0].clientWidth;
          angular.element('.monitor-error-message').css({ left: (-width / 2) + 39})
          angular.element('.monitor-error-message').css({ opacity: 1})
        }
        
        scope.hideMonitorErrorMessage = function () {
          angular.element('.monitor-error-message').css({ opacity: 0})
        }

        scope.checkPrinterNetworkConnection = function(printer) {
          var printerConnected = true;
          if (printer._embedded.status.pollStatus !== 'OK' || !printer._embedded.status._links['px:monitorWs']) {
            printerConnected = false
          }
          return printerConnected;
        }

        scope.setTonerVisual = function(COLOR) {
          if (printer.type === 'NETWORK') {
            $timeout(function() {
              var frameWidth = angular.element('.toner-frame')[0].clientWidth;
              angular.forEach(scope.statusPrinter._embedded.status.tonerLevels, function(toner) {
                var tonerWidth =  (frameWidth / 100) * toner.level;
                if (COLOR === toner.color) {
    
                  if (toner.level === 100) {
                    angular.element('#'+ COLOR + '_SOLID').css({'border-radius' : 3});  
                  }
    
                  if (COLOR === 'BLACK') {
                    angular.element('#'+ COLOR + '_SOLID').css({'background-color': COLOR, 'width': tonerWidth , 'opacity': 0.80})
                    angular.element('#'+ COLOR + '_SHADE').css({'background-color': COLOR, 'width': tonerWidth , 'opacity': 1, 'height': 3})
                  } else {
                    angular.element('#'+ COLOR + '_SOLID').css({'background-color': COLOR, 'width': tonerWidth , 'opacity': 0.60})
                    angular.element('#'+ COLOR + '_SHADE').css({'background-color': COLOR, 'width': tonerWidth , 'opacity': 1, 'height': 5})
                  }
                } 
              })
            }, 150)

          }
  
        }

        function dynamicWidth () {
          if (privateUsageType === 'tabs') {
            window.onresize = resizeColor;
          }
        }

        function resizeColor () {
          if (privateStatusPrinter.type !== 'VIRTUAL' && privateStatusPrinter._embedded.status.tonerLevels) { 
            privateStatusPrinter._embedded.status.tonerLevels.forEach((toner) => {
              scope.setTonerVisual(toner.color);
            })
          }
        }

  
        scope.getTonerLevel = function(toner) {
          if (toner.level) {
            return toner.level;
          } else {
            return '-'
          }
        }

        scope.getPrinterStatus = function() {
          scope.gettingPrinter = true;
          var printerModel = new PrinterModel(printer);
          $timeout(function  () {
            scope.showSpinner = true;
          }, 500)

          printerModel.refreshTonerStatus().then(function(printerStatus) { 
            scope.gettingPrinter = false;
            scope.showSpinner = false;
            printer = angular.copy(printerStatus.info);
            scope.statusPrinter = angular.copy(printerStatus.info);
            getMonitoringWorkstation();
            getNetwork();
            sortErrorsAndWarnings();
            sortToners();
            removeDeprecatedErrorsAndWarnings();
          }).catch(function(error){
            printerModel.retryRefreshStatus_NO_PARAMS().then(function(printerStatus) {
              scope.gettingPrinter = false;
              scope.showSpinner = false;
              printer = angular.copy(printerStatus.info);
              scope.statusPrinter = angular.copy(printerStatus.info);
              getMonitoringWorkstation();
              getNetwork();
              sortErrorsAndWarnings();
              sortToners();
              removeDeprecatedErrorsAndWarnings();
            }).catch(function(error){
              scope.gettingPrinter = false;
              scope.showSpinner = false;
            });
          });
        }

        scope.gotoPrinter = function () {
            var target = '/admin/#/printerProperties/' + scope.statusPrinter.customProperties.id;
            $window.open(target + '?printerSection=setup', '_blank');
        }


        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // TOOLTIP STUFF
        ////////////////////////////////////////////
        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          if (scope.usageType === 'popup') {
            var offsetLeft  =  angular.element('.context-content-container')[0].offsetLeft;  
            var offsetTop  =  angular.element('.context-content-container')[0].offsetTop;   
          }
          if (showTip) { 
            if (scope.usageType === 'popup') {
              position.startX = position.startX - offsetLeft; 
              position.startY = position.startY - offsetTop; 
            } 
            switch(tooltipScope) {
              case 'network':
                networkTooltip(position, context);
              break;
              case 'monitoringWorkstation':
                monitoringWorkstationTooltip(position, context);
              break;
            }
          } else {
            scope.clearTooltip();
          }
        }

        function networkTooltip (position, network) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: 'Network',
            type: 'networkDetails',
            network: network,
            tenant: TenantListService.currentTenant
          }
          scope.tooltipObject = {
            position: {left: position.startX - 15, top: position.startY + 20},
            contextMenu: scope.usageType === 'popup' ? true : false
          }
        }
        
        function monitoringWorkstationTooltip (position, workstation) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: 'Computer',
            type: 'workstationDetails',
            workstation: workstation,
            supportedOs: SUPPORTED_OS
          }
          scope.tooltipObject = {
            position: {left: position.startX - 15, top: position.startY + 20},
            contextMenu: scope.usageType === 'popup' ? true : false
          }
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        }


        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // LINKS OUT
        ////////////////////////////////////////////
        scope.gotoNetworkProperties = function (network) {
          var target = '/admin/#/networkProperties/'
          var id = network._links.self.href.split('networks/')[1]
          $window.open(target + id, '_blank');
        }

        scope.gotoWorkstationProperties = function (workstation) {
          var target = '/admin/#/computerProperties/'
          var id = workstation._links.self.href.split('workstations/')[1];
          $window.open(target + id,  '_blank')
        }

        

      }
    };
  }

  pxSitesPrinterStatus.$inject = [
    '$timeout', 'WorkstationListService', 'TenantListService', '$location', '$window', 'SUPPORTED_OS', 'NetworkListService',
    'PrinterModel', 'URLS', 'URL_PARAMS', '$rootScope'
  ];

  angular
    .module('printix-admin')
    .directive('pxSitesPrinterStatus', pxSitesPrinterStatus);

})();
